<template lang='pug'>
.navbar-search.navbar-search-desktop(:id="navbarSearchID" :class="searchActive ? 'navbar-search--active' : ''")
  input.navbar-input.text--18.color--greyCharcoal30(id="navbar-input" placeholder="搜尋話題" v-model="searchKeyword" @click="searchActive = !searchActive" autocomplete="off")
  .navbar-clearIcon(@click="clearSearchBox()")
    i.icon-searchdelete
  .navbar-searchKeywords
    i.navbar-iconSearch(@click="search()")
  .navbar-searchListWrapper(v-if="searchActive")
    .navbar-searchList
      .navbar-searchItem(v-for="text in navbarSearchText" @click="clickOption(text)")
        span.navbar-searchText {{ text }}
        i.navbar-searchIcon.icon-searched
</template>

<script>
import $ from 'jquery'
export default {
  props: {
    userProfile: Object,
    navbarSearchText: Array
  },
  data() {
    return {
      searchKeyword: this.$route.query.keyword ? this.$route.query.keyword : "",
      searchActive: false,
      hasCompletedTyping: true,
      navbarSearchID: "navbar-search-id"
    }
  },
  mounted() {
    $('#navbar-input').on('compositionstart', () => {
      this.hasCompletedTyping = false
    })
    $('#navbar-input').on('compositionend', () => {
      setTimeout(() => {
        this.hasCompletedTyping = true
      },0)
    })
    $("#navbar-input").keypress( (e) => {
      if (e.key == 'Enter')
        if (this.hasCompletedTyping)
          this.search()
    })
    $(document).click((e) => {
      if (document.getElementById(this.navbarSearchID))
        if (!$.contains(document.getElementById(this.navbarSearchID), e.target))
          this.searchActive = false
    });
  },
  methods: {
    clearSearchBox() {
      this.searchKeyword = "" 
    },
    search() {
      let trimKeyWord = $.trim(this.searchKeyword)
      if (trimKeyWord.length == 0) return
      this.$router.push({
        "path": "/category",
        "query": {
          "type": "searchArticles",
          "keyword": trimKeyWord
        }
      })
      this.searchActive = false
    },
    clickOption(text) {
      this.searchKeyword = text
      this.search()
    }
  }
}
</script>
<style scoped src='./navbar_search_desktop.vue.css'></style>
